import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomField } from '@assetaccountant/api/models/custom-field';
import { CustomFieldApi } from '@assetaccountant/api/services/custom-field.api';
import { ValidSubmitEvent } from '@assetaccountant/core/directives/forms/valid-submit.directive';
import { RegisterObjectId } from '@assetaccountant/core/models/register-object-id';
import { CustomFieldFormService } from '@assetaccountant/core/services/custom-field-form.service';
import { ToastrService } from 'ngx-toastr';
import { ActiveSidePanel } from '../../side-panel/side-panel.component';

@Component({
  selector: 'app-custom-fields-edit-side-panel',
  templateUrl: './custom-fields-edit-side-panel.component.html',
  styleUrls: ['./custom-fields-edit-side-panel.component.scss'],
  standalone: false,
})
export class CustomFieldsEditSidePanelComponent implements OnInit {
  @Input() id: RegisterObjectId;
  @Input() customFields: CustomField[];

  @Output() customFieldsUpdated = new EventEmitter<CustomField[]>();

  form = this.customFieldFormService.createFormArray();
  errors?: any;

  constructor(
    private customFieldApi: CustomFieldApi,
    private customFieldFormService: CustomFieldFormService,
    private activeSidePanel: ActiveSidePanel,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.customFieldFormService.setFormCustomFields(this.form, this.customFields);
  }

  onClose() {
    this.activeSidePanel.close();
  }

  onSubmit({ handle }: ValidSubmitEvent) {
    const customFields = this.customFieldFormService.getFormCustomFields(this.form);

    const apiCall = this.customFieldApi.update({
      objectType: this.id.objectType,
      objectId: this.id.objectId,
      customFields,
    });

    handle(apiCall).subscribe({
      next: () => {
        this.toastr.success('Custom fields successfully added');
        this.customFieldsUpdated.emit(customFields);
        this.activeSidePanel.close();
      },
      error: error => {
        this.errors = error.error;
        console.error('Error adding custom fields:', error);
        this.toastr.error('Error adding custom fields');
      },
    });
  }
}
